import { Injectable } from '@angular/core';
import { CePopoverActiveTrigger } from './ce-popover-active.types';

@Injectable({ providedIn: 'root' })
export class CePopoverActiveService {
    #activeTrigger: CePopoverActiveTrigger | null = null;

    register(trigger: CePopoverActiveTrigger): void {
        if (this.#activeTrigger && this.#activeTrigger !== trigger) {
            this.#activeTrigger.hidePopup();
        }
        this.#activeTrigger = trigger;
    }

    unregister(trigger: CePopoverActiveTrigger): void {
        if (this.#activeTrigger === trigger) {
            this.#activeTrigger = null;
        }
    }
}
